export { default as CreateProjectInTeamFormTasksListTotals } from './CreateProjectInTeamFormTasksListTotals';
